import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as FollowupActions from '~/repositories/followup/store/followup.actions';
import { FollowUpTask } from '~/repositories/followup/store/followup.models';

export interface FollowupState extends EntityState<FollowUpTask> {
  loaded?: boolean;
  error?: string | null;
}

export const followupAdapter: EntityAdapter<FollowUpTask> = createEntityAdapter<FollowUpTask>();

export const initialFollowupState: FollowupState = followupAdapter.getInitialState({
  loaded: false
});

const reducer = createReducer(
  initialFollowupState,
  on(FollowupActions.fetchFollowupsForDecree, (state) => ({
    ...state,
    loaded: false,
    error: null
  })),
  on(FollowupActions.fetchFollowupsForDecreeSuccess, (state, { followupTasks }) =>
    followupAdapter.setAll(followupTasks, {
      ...state,
      loaded: true
    })
  ),
  on(FollowupActions.fetchFollowupsForDecreeFailure, (state, { error }) => ({
    ...state,
    error
  })),
  on(FollowupActions.publishFollowup, (state) => ({
    ...state
  })),
  on(FollowupActions.publishFollowupSuccess, (state, { followup }) => followupAdapter.addOne(followup, state)),
  on(FollowupActions.publishFollowupFailure, (state, { error }) => ({
    ...state,
    error
  })),
  on(FollowupActions.removeFollowupTask, (state) => ({
    ...state
  })),
  on(FollowupActions.removeFollowupTaskSuccess, (state, { taskId }) => followupAdapter.removeOne(taskId, state)),
  on(FollowupActions.removeFollowupTaskFailed, (state, { error }) => ({
    ...state,
    error
  })),
  on(FollowupActions.updateStatus, (state) => ({
    ...state
  })),
  on(FollowupActions.updateStatusSuccess, (state, { followupTasks }) =>
    followupAdapter.updateMany(
      followupTasks.map((followup) => ({ id: followup.id, changes: followup })),
      state
    )
  ),
  on(FollowupActions.updateStatusFailed, (state, { error }) => ({
    ...state,
    error
  })),
  on(FollowupActions.updateFollowupTask, (state) => ({
    ...state
  })),
  on(FollowupActions.updateFollowupTaskSuccess, (state, { followupTask }) =>
    followupAdapter.updateOne({ id: followupTask.id, changes: followupTask }, state)
  ),
  on(FollowupActions.updateFollowupTaskFailed, (state, { error }) => ({
    ...state,
    error
  })),
  on(FollowupActions.assignTasks, (state) => ({
    ...state
  })),
  on(FollowupActions.assignTasksSuccess, (state, { followupTasks }) =>
    followupAdapter.updateMany(
      followupTasks.map((followup) => ({ id: followup.id, changes: followup })),
      state
    )
  ),
  on(FollowupActions.assignTasksFailed, (state, { error }) => ({
    ...state,
    error
  }))
);

export function followupReducer(state: FollowupState, action: Action) {
  return reducer(state, action);
}
